import { Button } from "@/components/ui/button";
import { forwardRef } from "react";
import { useNavigate } from "react-router-dom";
import { Workflow } from "../types";
import Canvas from "./Canvas";
import Container from "./Container";
import Sidebar from "./Sidebar";
import { WorkflowProvider } from "./workflow-context";

interface LayoutProps extends Workflow {
  readonly?: boolean;
  embed?: boolean;
  userToken: string | null;
}

const WorkflowCanvas = forwardRef((props: LayoutProps, ref) => {
  const { readonly, embed } = props;
  const version = props.nodes.length > 0 && props.nodes[0]?.workflow_version_id;
  const first_node_id = props.nodes.length > 0 && props.nodes[0]?.id;
  const navigate = useNavigate();

  return (
    <WorkflowProvider
      ref={ref}
      workflow={{
        ...props,
        nodes: props.nodes.map((node) => ({ ...node, saved: true })),
      }}
      key={`${props.workflow_id}_${version}_${first_node_id}`}
    >
      <Container>
        {embed && (
          <div className="absolute right-4 top-4 z-50">
            <Button
              onClick={() =>
                navigate(
                  `/workspace/${props.workspace_id}/workflow/${props.workflow_id}`,
                )
              }
              variant="default"
              className="transition-all hover:scale-105 hover:shadow-md"
              aria-label="Open agent in full view"
            >
              Open Agent <span className="ml-1 font-semibold">→</span>
            </Button>
          </div>
        )}
        <Canvas readonly={readonly} />
        <Sidebar readonly={readonly} />
      </Container>
    </WorkflowProvider>
  );
});

export default WorkflowCanvas;
